import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import Routes instead of Switch
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import Support from './components/Support';

const App = () => {
  return (
    <Router>
      <Routes> {/* Use Routes instead of Switch */}
        <Route path="/" element={<Home />} /> {/* Use element prop instead of component */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Use element prop instead of component */}
        <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/support.html" element={<Support />} />
      </Routes>
    </Router>
  );
}

export default App;
